import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

// Real routes only. Deliberately not a sitemap — the header carries navigation;
// this is the second path people look for when they want to reach a human.
const LINKS = [
  { to: '/contact', label: 'Contact' },
  { to: '/faq', label: 'FAQ' },
  { to: '/about', label: 'About' },
]

function Footer() {
  return (
    <footer className="ft">
      <div className="ft__inner">
        <span className="ft__credit">Copyright &copy; PCRAssist.com</span>
        <nav className="ft__links" aria-label="Footer">
          {LINKS.map(({ to, label }) => (
            <Link className="ft__link" key={to} to={to}>
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  )
}

export default Footer
